var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxeonChemical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 48",
    style: {
      enableBackground: "new 0 0 350 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0B0C0C;}\r\n\t.st1{fill:#03BCDD;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.9,18c0.1,2.9-2.3,5.4-5.2,5.4c-2.9,0.1-5.4-2.3-5.4-5.2c-0.1-2.9,2.3-5.4,5.2-5.4c0.1,0,0.1,0,0.2,0 c2.8-0.1,5.2,2.2,5.2,5C194.9,17.9,194.9,17.9,194.9,18 M185.6,18c0,2.2,1.9,4,4.1,4c2.2,0,4-1.9,4-4.1s-1.8-4-4-4s-4.1,1.8-4.1,4 V18 M188.8,20.7h-1.2v-5.2c0.5,0,1.2-0.1,2-0.1c0.9,0,1.5,0.1,1.7,0.4c0.3,0.3,0.5,0.7,0.5,1.1c0,0.6-0.5,1.1-1.1,1.2l0,0 c0.5,0.1,0.8,0.5,0.9,1.3c0.1,0.5,0.2,0.9,0.4,1.3h-1.3c-0.2-0.4-0.3-0.8-0.4-1.3c-0.1-0.5-0.5-0.9-1-0.8c0,0,0,0-0.1,0h-0.5 L188.8,20.7z M188.8,17.8h0.5c0.7,0,1.2-0.3,1.2-0.8s-0.4-0.8-1.1-0.8h-0.7L188.8,17.8L188.8,17.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.3,12.4v-0.1H69l-11.2,25h5.5l2.1-4.6H78l2.1,4.6h5.5L74.3,12.4z M75.8,27.9h-8.5l4.3-9.8L75.8,27.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98,24.6 106.2,12.3 100.9,12.3 94.8,21.3 88.8,12.3 83.4,12.3 91.6,24.6 83.1,37.3 88.6,37.3  94.8,28.1 101,37.3 106.5,37.3  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "128.2,17.1 128.2,12.3 109.4,12.3 109.4,37.3 128.2,37.3 128.2,32.3 114.4,32.3 114.4,27.1  127.7,27.1 127.7,22.4 114.4,22.4 114.4,17.1  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.3,15.3c-2.3-2.3-5.5-3.6-9.1-3.6c-8.8,0-12.8,6.8-12.8,13.2s4,12.9,12.8,12.9s12.7-6.5,12.8-12.9 C157.1,21.3,155.8,17.9,153.3,15.3 M138.6,18.5c1.4-1.4,3.3-2.2,5.6-2.2s4.1,0.7,5.5,2.1c1.5,1.6,2.4,3.9,2.3,6.5 c-0.1,4-2.2,8.2-7.9,8.2s-7.8-4.2-7.9-8.2C136.2,22.6,137,20.3,138.6,18.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "176.3,12.2 176.3,27.1 164.5,12.3 160.5,12.3 160.5,37.3 165.5,37.3 165.5,21 178.1,37.3 181.3,37.3  181.3,12.2  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,43.7c0.2-0.4,1.9-3.6,2.7-4.7c0.8-1.3,1.8-2.6,2.9-3.8c5.8-6.5,13.4-9.2,20.5-7.9 c1.6,0.3,3.2,0.8,4.6,1.6c0.2,0.1,0.3,0.2,0.5,0.3L33.9,5.5c-0.6-1.1-1.4-2-2.4-2.7c-1.1-0.7-2.3-1.2-3.6-1.4 c-0.5-0.1-1-0.1-1.5-0.1c-0.4,0-0.9,0-1.4,0c-1.3,0.1-2.5,0.5-3.6,1.2s-2,1.6-2.6,2.6C18.7,5.2,2.5,36.3,2.5,36.4l0,0 c-0.8,1.4-1.1,2.9-0.9,4.5c0.2,1.5,0.9,2.9,2,4c1.6,1.6,3.9,2.4,6.1,2.1c0.7-0.1,1.4-0.3,2.1-0.5C13.2,46.1,14.4,45,15.2,43.7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,34.6c-3.8-4.2-9.6-5.9-15.1-4.4c-10.8,3-13.8,11.7-13.8,11.7s11.5-8.1,18.4,1.8c0.6,0.9,0.6,0.9,0.8,1.2 c2.2,2.5,5.8,3.2,8.7,1.6C51.2,44.6,53,39.2,48.8,34.6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.5,34.4H202.2c-1.6,0-3-1.1-3-2.5l0,0V18.7c0-1.4,1.4-2.5,3-2.5l0,0h120.3c1.6,0,3,1.1,3,2.5l0,0v13.2 C325.5,33.3,324.2,34.4,322.5,34.4"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.7,26.3l3.1,0.9c-0.2,0.9-0.5,1.6-1,2.2s-1,1-1.7,1.3s-1.5,0.4-2.5,0.4c-1.2,0-2.3-0.2-3.1-0.5 c-0.8-0.4-1.5-1-2-1.9c-0.6-0.9-0.9-2.1-0.9-3.5c0-1.9,0.5-3.4,1.5-4.4s2.4-1.5,4.3-1.5c1.4,0,2.6,0.3,3.4,0.9s1.4,1.5,1.8,2.7 l-3.1,0.7c-0.1-0.3-0.2-0.6-0.3-0.8c-0.2-0.3-0.4-0.5-0.7-0.6s-0.6-0.2-1-0.2c-0.8,0-1.4,0.3-1.8,1c-0.3,0.5-0.5,1.2-0.5,2.3 c0,1.3,0.2,2.1,0.6,2.6s0.9,0.7,1.6,0.7c0.7,0,1.2-0.2,1.5-0.6S212.5,27,212.7,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.7,19.6h3.5v4h3.9v-4h3.6V31h-3.6v-4.6h-3.9V31h-3.5V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.2,19.6h9.5V22h-5.9v1.8h5.5v2.3h-5.5v2.3h6.1V31h-9.7V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.9,19.6h4.7l1.8,7l1.8-7h4.7V31h-2.9v-8.7l-2.2,8.7h-2.6l-2.2-8.7V31h-2.9V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.4,19.6h3.5V31h-3.5V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.3,26.3l3.1,0.9c-0.2,0.9-0.5,1.6-1,2.2s-1,1-1.7,1.3s-1.5,0.4-2.5,0.4c-1.2,0-2.3-0.2-3.1-0.5 c-0.8-0.4-1.5-1-2-1.9c-0.6-0.9-0.9-2.1-0.9-3.5c0-1.9,0.5-3.4,1.5-4.4s2.4-1.5,4.3-1.5c1.4,0,2.6,0.3,3.4,0.9s1.4,1.5,1.8,2.7 l-3.1,0.7c-0.1-0.3-0.2-0.6-0.3-0.8c-0.2-0.3-0.4-0.5-0.7-0.6s-0.6-0.2-1-0.2c-0.8,0-1.4,0.3-1.8,1c-0.3,0.5-0.5,1.2-0.5,2.3 c0,1.3,0.2,2.1,0.6,2.6s0.9,0.7,1.6,0.7c0.7,0,1.2-0.2,1.5-0.6S287.2,27,287.3,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.4,29.1h-4l-0.6,1.9h-3.6l4.3-11.5h3.9l4.3,11.5H303L302.4,29.1z M301.7,26.6l-1.3-4.1l-1.3,4.1H301.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311,19.6h3.5v8.6h5.5V31H311V19.6z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 172.8,
    y: 94.1,
    style: {
      fill: "none"
    },
    width: 125.5,
    height: 24.8
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 172.7743 105.507)",
    className: "st2",
    style: {
      fontFamily: "'Arial-Black'",
      fontSize: 16
    }
  }, "Chemical"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxeonChemical);
export default __webpack_public_path__ + "static/media/axeon-chemical.b1cf67db1e78f51dd902e26a4ab1b9b3.svg";
export { ForwardRef as ReactComponent };